import React from 'react'
import Header from '../../molecules/Header'
import ComingSoonPage from './Coming'
import ResponsiveFooter from '../../molecules/ResponsiveFooter'

const ComingSoon = () => {
  return (
    <>
     <Header/>
     <ComingSoonPage/>
     <ResponsiveFooter/> 
    </>
  )
}

export default ComingSoon
